"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    staleWhileRevalidateFetch: ()=>staleWhileRevalidateFetch
});
const external_util_js_namespaceObject = require("./util.js");
const external_helpers_js_namespaceObject = require("./helpers.js");
const staleWhileRevalidateFetch = async (param)=>{
    let { request, cacheName, timeout = 8000, attachFetchStrategyToResponseHeader } = param;
    const cacheService = new external_util_js_namespaceObject.CacheService(cacheName);
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>{
        controller.abort();
    }, timeout);
    const fetchAndCachePromise = fetch(request, {
        signal: controller.signal
    }).finally(()=>clearTimeout(timeoutId)).then((fetchResponse)=>{
        if (fetchResponse.status >= 400) throw new Error('status code error');
        const clonedResponse = fetchResponse.clone();
        const finalResponse = attachFetchStrategyToResponseHeader ? (0, external_helpers_js_namespaceObject.cloneResponseWithSourceHeader)(clonedResponse) : clonedResponse;
        cacheService.put(request, finalResponse);
        return fetchResponse;
    }).catch((err)=>{
        console.error(err);
    });
    let response = await cacheService.match(request);
    if (response) return response;
    {
        let err = new Error('empty response');
        try {
            response = await fetchAndCachePromise;
        } catch (error) {
            err = error;
        }
        if (!response) throw err;
        return response;
    }
};
exports.staleWhileRevalidateFetch = __webpack_exports__.staleWhileRevalidateFetch;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "staleWhileRevalidateFetch"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
